export class AuthenticationError extends Error {
    readonly name: string = "AuthenticationError";
    readonly internalError?: unknown;

    constructor(message: string, internalError?: unknown) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);

        this.internalError = internalError;
    }
}
